<section class="customers-page">

  <!-- ── Header ─────────────────────────────────────────────────────────── -->
  <div class="page-header">
    <h1>Customers</h1>
  </div>

  <!-- ── Filter row ─────────────────────────────────────────────────────── -->
  <div class="filter-bar">

    <!-- Name / ID search -->
    <div class="filter-search">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        class="search-input"
        type="search"
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
        placeholder="Search by name or user ID…"
      />
    </div>

    <!-- Email filter -->
    <div class="filter-search">
      <mat-icon class="search-icon">email</mat-icon>
      <input
        class="search-input"
        type="search"
        [ngModel]="emailQuery()"
        (ngModelChange)="emailQuery.set($event)"
        placeholder="Filter by email…"
      />
    </div>

    <!-- City multi-select -->
    <div class="city-filter">
      <button
        type="button"
        class="filter-btn"
        [class.filter-btn--active]="cityFilter().length > 0"
        (click)="cityDropdownOpen = !cityDropdownOpen"
      >
        <mat-icon class="filter-btn-icon">location_on</mat-icon>
        @if (cityFilter().length > 0) {
          Cities ({{ cityFilter().length }})
        } @else {
          All cities
        }
        <mat-icon class="filter-btn-chevron">expand_more</mat-icon>
      </button>
      @if (cityDropdownOpen) {
        <div class="city-dropdown">
          @if (cityOptions().length === 0) {
            <span class="city-dropdown-empty">No cities available</span>
          }
          @for (opt of cityOptions(); track opt.code) {
            <label class="city-option">
              <input
                type="checkbox"
                [checked]="isCitySelected(opt.code)"
                (change)="toggleCity(opt.code)"
              />
              {{ opt.label }}
            </label>
          }
        </div>
      }
    </div>

  </div>

  <!-- ── Table panel ────────────────────────────────────────────────────── -->
  <div class="table-panel">
    @if (loading()) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
      </div>
    } @else if (error()) {
      <div class="empty error-text">{{ error() }}</div>
    } @else {
      <div class="table-wrap">
        @if (users().length) {
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>City</th>
                <th>Address</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              @for (u of users(); track u.id) {
                <tr>

                  <!-- Name + ID -->
                  <td class="name-cell">
                    <div class="cell-stack">
                      <span class="user-name">{{ u.preferred_name || '—' }}</span>
                      <span class="user-id">{{ u.id }}</span>
                    </div>
                  </td>

                  <!-- Email -->
                  <td class="email-cell">{{ u.email || '—' }}</td>

                  <!-- Phone -->
                  <td class="phone-cell">{{ u.phone || '—' }}</td>

                  <!-- City -->
                  <td class="city-cell">
                    @if (u.city_code) {
                      <span class="city-chip">{{ u.city_code }}</span>
                    } @else {
                      <span class="muted">—</span>
                    }
                  </td>

                  <!-- Address -->
                  <td class="address-cell">
                    <span class="muted">{{ u.address || '—' }}</span>
                  </td>

                  <!-- Joined -->
                  <td class="date-cell">{{ formatDate(u.joined_at) }}</td>

                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div class="empty">No customers found.</div>
        }
      </div>
    }
  </div>

</section>